module.exports = __webpack_public_path__ + "static/media/09d.a3252874.png";